import { Component } from '@angular/core';
import { EmployeeService } from '../employee.service';
import {HttpResponse, HttpEventType, HttpHeaders } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { Observable } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms'

@Component({
  selector: 'app-upload-item',
  templateUrl: './upload-item.component.html',
  styleUrls: ['./upload-item.component.css']
})
export class UploadItemComponent {

  selectedFiles: FileList;
  currentFile: File;
  progress = 0;
  message = '';
  tscEmp : any;
  tscItem : any;
  tscInventory : any;
  approvalItems : any;

 

  constructor(private uploadService: EmployeeService) { }
  
  
  sheets =[
	{ id: 'TSC_Emp', select : false , name:'TSC_Emp' },
	{ id: 'ITEM_List', select : false , name:'ITEM_List' },
	{ id: 'TSC_Inv', select : false , name:'TSC_Inv' },
	{ id: 'Approval_items', select : false , name:'Approval_items' }
];

onChangeCheckBox($event){
const id= $event.target.value;
const isChecked = $event.target.checked;
console.log(id,isChecked);



this.sheets.forEach((ids, select, name) => {
  
    if(ids.id===id){
	ids.select = isChecked;
}
    // 100, 200, 300
    /*console.log(select); // 0, 1, 2
    console.log(name); // same myArray object 3 times*/
});
console.log(this.sheets);




/*this.sheets = this.sheets.map((d) => {
	if (d.id === id){
		d.select = isChecked;
		return d;
	}
	return d;
});
console.log(this.sheets);
*/}

  selectFile(event): void {
    this.selectedFiles = event.target.files;
  }

  upload(): void {
    this.progress = 0;
    
    console.log(this.tscEmp);
    console.log(this.tscItem);
    console.log(this.tscInventory);
    console.log(this.approvalItems);
    console.log(this.sheets);
    
    let headers = new HttpHeaders();
    headers.append('filesToProcess',this.sheets.toString());
    
    this.currentFile = this.selectedFiles.item(0);
    this.uploadService.uploadItems(this.currentFile,JSON.stringify(this.sheets)).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progress = Math.round(100 * event.loaded / event.total);
          console.log(`Uploaded! ${this.progress}%`);
        } 
        else if (event instanceof HttpResponse) {
          this.message = 'File Uploaded Succesfuly!';
       

        }
      },
      err => {
        this.progress = 0;
        this.message = 'Could not upload the file!';
        this.currentFile = undefined;
      });

    this.selectedFiles = undefined;
  }

  refresh(): void {
    window.location.reload();
}



}
